import { StepType } from '@reactour/tour';
import React from 'react';

export const overviewTourSteps: Array<StepType> = [
	{
		selector: `.user-account-stats`,
		content: (
			<div>
				<h6>Account Stats</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'bottom',
	},
	{
		selector: `.overview-activity-container`,
		content: (
			<div>
				<h6>Recent Activity</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'center',
	},
	{
		selector: `.side-navigation-entry[title='Mailboxes']`,
		content: (
			<div>
				<h6>Mailboxes</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'top',
	},
	{
		selector: `.side-navigation-entry[title='Send Mail']`,
		content: (
			<div>
				<h6>Send Mail</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'right',
	},
	{
		selector: `.side-navigation-entry[title='Message Centre']`,
		content: (
			<div>
				<h6>Message Centre</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'right',
	},
	{
		selector: `.user-overview-nav`,
		position: 'right',
		content: (
			<div>
				<h6>Settings</h6>
				<p>
					Here's where you'll find your account details along with further guidance on how to set up your
					account.
				</p>
				<p className='mb-xs'>Update your:</p>
				<ul>
					<li>Default Actions</li>
					<li>Notifications</li>
					<li>Third Party Integrations</li>
					<li>And more...</li>
				</ul>
			</div>
		),
		actionAfter: () => console.log('finished '),
	},
];
